export default __webpack_public_path__ + "static/media/ajax-loader.19e6b04b.gif";